import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IoIosClose } from 'react-icons/io';

import { Button } from '@mssgme/ui';
import { __t } from '@mssgme/shared';
import styles from './styles.scss';

export class CardReviewRecommendModal extends React.Component {
    el = document.createElement('div');

    static propTypes = {
        recommend: PropTypes.bool.isRequired,
        fullName: PropTypes.string.isRequired,
        closeModalFn: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        minLength: PropTypes.number,
        maxLength: PropTypes.number,
    };

    static defaultProps = {
        minLength: 25,
        maxLength: 2000,
    };

    state = {
        message: '',
    };

    handleChange = (e) => {
        const value = e.target.value;

        this.setState({ message: value });
    };

    componentDidMount() {
        const modalRoot = document.getElementById('cardRoot');
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        const modalRoot = document.getElementById('cardRoot');
        modalRoot.removeChild(this.el);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { onSubmit, recommend } = this.props;
        const { message } = this.state;

        onSubmit({ recommend, message });
    };

    render() {
        const { recommend, fullName, closeModalFn, maxLength, minLength } = this.props;
        const { message } = this.state;
        const normalizedMessage = message.trim();

        return ReactDOM.createPortal(
            <div className={styles.root}>
                <form className={styles.modalPane} onSubmit={this.handleSubmit}>
                    <div className={classNames(styles.header, recommend ? styles.green : styles.red)}>
                        <h1>{fullName}</h1>
                        <span className={styles.closeButton} onClick={closeModalFn}>
                            <IoIosClose size={32} color="#fff" />
                        </span>
                    </div>
                    <textarea
                        className={styles.commentArea}
                        name="message"
                        onChange={this.handleChange}
                        value={message}
                        maxLength={maxLength}
                        placeholder={__t('what_recommend', [fullName])}
                    />
                    <div className={styles.footer}>
                        <span className={styles.footerMeta}>
                            {__t('minimum_characters', [normalizedMessage.length])}
                        </span>
                        <Button
                            data-btn="sendReviewButton"
                            type="submit"
                            disabled={normalizedMessage.length < minLength}
                            size="small"
                            btnStyle="primary"
                        >
                            {__t('send')}
                        </Button>
                    </div>
                </form>
            </div>,
            this.el
        );
    }
}
